import HomeOutlineNine from '@assets/icons/home-outline-nine.svg'
import { Icon } from './Icon'

export const HomeOutlineNineIcon = Icon(HomeOutlineNine)
